import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ContextService } from '../context.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ReminderDefService } from '@savvy/reminders';
import { ContextIdDto } from '@savvy/view-definition';
import { Subscription } from 'rxjs';
import { ClearObservable } from '../shared/classes/clear-observable';
import { takeUntil } from 'rxjs/operators';
import { fromReminderDefV3Response, ReminderDefV3Summary } from './reminderDefV3.adapter';

@Component({
  selector: 'app-add-edit-reminder-def-page',
  templateUrl: './addEditReminderDefPage.component.html',
  providers: [
  ]
})
export class AddEditReminderDefPageComponent extends ClearObservable implements OnInit, OnChanges {
  @Input() reminderDefId: string;
  sub: any;
  reminderDef: ReminderDefV3Summary;
  contextIdDto: ContextIdDto;
  subscriptions: Subscription[] = [];

  reminderDefLoaded = false;
  reminderDefNotFound = false;
  reminderDefLoadFailed = false;
  private loadedReminderKey: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private reminderDefApi: ReminderDefService,
    public contextService: ContextService) {
    super();
  }


  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => this.setRouteParameters(params));

    this.route.parent?.params
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => this.setRouteParameters(params));

    this.contextService.contextIdDto$
      .pipe(takeUntil(this.destroy$))
      .subscribe(contextIdDto => {
        if (contextIdDto?.contextId && contextIdDto.contextIdType) {
          this.contextIdDto = contextIdDto;
          this.loadReminderDefWhenReady();
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['reminderDefId']) {
      this.loadReminderDefWhenReady();
    }
  }

  private setRouteParameters(params: { [key: string]: string }): void {
    if (params['reminderDefId']) {
      this.reminderDefId = params['reminderDefId'];
    }
    if (params['contextId'] && params['contextIdType']) {
      this.contextIdDto = {
        contextId: params['contextId'],
        contextIdType: params['contextIdType'],
      } as ContextIdDto;
    }
    this.loadReminderDefWhenReady();
  }

  private loadReminderDefWhenReady(): void {
    if (!this.reminderDefId || !this.contextIdDto?.contextId || !this.contextIdDto.contextIdType) {
      return;
    }

    const reminderKey = `${this.reminderDefId}:${this.contextIdDto.contextId}:${this.contextIdDto.contextIdType}`;
    if (this.loadedReminderKey === reminderKey) {
      return;
    }
    this.loadedReminderKey = reminderKey;
    this.loadReminderDef(this.reminderDefId);
  }

  private loadReminderDef(reminderDefId: string): void {
    this.reminderDefLoaded = false;
    this.reminderDefNotFound = false;
    this.reminderDefLoadFailed = false;
    console.info('[v2 reminders] loading routed reminder definition');
    this.reminderDefApi.loadSummaries().subscribe({
      next: reminderDefs => {
        const reminderDef = reminderDefs.find(summary => summary.id === reminderDefId);
        this.reminderDef = reminderDef && fromReminderDefV3Response(reminderDef);
        this.reminderDefLoaded = true;
        this.reminderDefNotFound = !this.reminderDef;
        console.info('[v2 reminders] routed reminder definition loaded', {
          reminderDefinitionCount: reminderDefs.length,
          found: Boolean(this.reminderDef),
        });
      },
      error: error => {
        this.reminderDefLoadFailed = true;
        console.error('[v2 reminders] routed reminder definition failed to load', {
          message: error?.message,
        });
      },
    });
  }

  retryLoadReminderDef(): void {
    this.loadedReminderKey = undefined;
    this.loadReminderDefWhenReady();
  }

}
